export default __webpack_public_path__ + "static/media/สมาชิกใหม่รับ100v2.32a5c5eb.png";